import { h, Fragment } from "preact";
import { useState, useEffect, useContext } from "preact/hooks";

import { Backdrop, Box, Button, Grid, Link, Paper, Stack, Step, Stepper, StepLabel, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { useCookies } from "react-cookie";
import CommonDetails from "../UserDetails/CommonDetails";
import BuyerDetailsStep2 from "../UserDetails/BuyerDetailsStep2";
import SellerDetailsStep3 from "../UserDetails/SellerDetailsStep3";
import palette from "../../theme/palette";
import TunnelTerminaison from "../Common/TunnelTerminaison";
import ConfirmPhone from "../ConfirmPhone";
import { resendconfmail, resendconfphone } from "../Common/functions";
import { AppContext } from "../../AppContext";
const useStyles = makeStyles((theme) => ({
	backdrop: {
		zIndex: theme.zIndex.drawer + 1,
		color: "#fff",
	},
}));

export default function DevenirAcquereur(props) {
	console.log("DevenirVendeur", props);
	const app = useContext(AppContext);
	//console.log(window.location.href);
	//console.log(window.location.href.startsWith("http://localhost"));
	const [devMode, setDevMode] = useState(window.location.href.startsWith("http://localhost"));
	const classes = useStyles();
	//setDevMode(window.location.href.startsWith("http://localhost"))
	const dev_state = {
		step: props.step ? parseInt(props.step) : 0,
		gender: "1",
		lastname: "Guillaume",
		firstname: "Besse" + Math.floor(Math.random() * 1000),
		email: "guillaume.besse+bk" + Math.floor(Math.random() * 1000000) + "@telemetis.com",
		pwd1: "******",
		pwd2: "******",
		tel1: "+33637574129",
		tel2: "",
		adr1: "7 rue de la rénière",
		adr2: "bat B",
		zipcode: "92300",
		city: "Levallois-Perret",
	};
	const prod_state = {
		step: 0,
		gender: "",
		lastname: "",
		firstname: "",
		email: "",
		pwd1: "",
		pwd2: "",
		tel1: "",
		tel2: "",
		adr1: "",
		adr2: "",
		zipcode: "",
		city: "",
	};
	const [cookies, setCookie, removeCookie] = useCookies(["_bkeys"]);
	const [state, setState] = useState(devMode ? dev_state : prod_state);
	const steps = ["Mes informations", "Mon adresse", "Validation"];



	useEffect(() => {
		//console.log("useEffect", state, props);
		switch (props.step) {
			case undefined:
				removeCookie("_bkeys");
				removeCookie("_bkuser");
				break;
			default:
				// retrieve data from session

				const requestOptions = {
					method: "GET",
					headers: { "Content-Type": "application/json" },
				};

				fetch("/api/e45708b8f5bb413786417d165c9b2e99", requestOptions)
					.then((response) => {
						return response.json();
					})
					.then((res) => {
						switch (res.res) {
							case "ok":
								setState({
									...state,
									...res.payload,
									loaded: true,
								});
								break;

							case "err":

								break;
							default:
								break;
						}
					});
		}
	}, []);

	const [backDrop, setBackDrop] = useState(false);


	const [verifCode, setVerifCode] = useState(false);
	const handleOpenVerifCode = (event, reason) => {
		setVerifCode(!verifCode);
	};


	return (
		<div style="padding: 20px;">

			<Backdrop open={backDrop} className={classes.backdrop}></Backdrop>
			<Grid container spacing={2}>

				<Grid item xs={12}>
					<Paper style="padding: 20px;">
						{" "}
						<Stepper activeStep={state.step} alternativeLabel>
							{steps.map((label) => (
								<Step key={label}>
									<StepLabel>{label}</StepLabel>
								</Step>
							))}
						</Stepper>
					</Paper>
				</Grid>

				<Grid item xs={3}>
					<Paper style="padding: 10px; height: 100%; background-color: rgb(240,240,240)">
						{props.step === "0" && <Typography variant="h6"><div>
							<Typography variant="h6" style="padding-bottom: 20px;">
								Bienvenue
							</Typography>
							<Typography variant="caption">
								En cliquant sur s'inscrire, vous acceptez les conditions générales de Bkeys. Pour en savoir plus sur
								le traitement de vos données et vos droits, veuillez consulter la{" "}
								<a href="https://bkeys.com/cgv">Politique de confidentialité</a> de Bkeys. Vous avez le droit d'accéder à vos données personnelles, d'y apporter toute rectification ou modification.
								Vous avez également la possibilité de supprimer votre compte et de vous opposer à l'utilisation de vos données à des fins de
								prospection commerciale.
							</Typography>
						</div></Typography>}
						{props.step === 1 && <Typography variant="h6">C00101</Typography>}

						{props.step === 2 && <Typography variant="h6">C00102</Typography>}
						{props.step === 3 && <Typography variant="h6">C00103</Typography>}
					</Paper>
				</Grid>
				<Grid item xs={9}>
					<Grid container spacing={1}>

						<Grid item xs={12}>
							<Paper
								style="padding: 8px; "
							>
								<Stack spacing={1}>
									<Typography variant="h5" color="primary">Acheter un bien</Typography>
									<Typography>Obtenez l’adresse exacte de votre futur bien</Typography>
									<Typography>Et prenez rendez-vous en ligne</Typography>
								</Stack>
							</Paper>
						</Grid>
						<Grid item xs={12}>
							<Paper style="padding: 10px;">
								{props.step === "0" && (
									<CommonDetails
										mode={"P"}
										state={state}
										setState={setState}
										setBackDrop={setBackDrop}

									/>
								)}
								{props.step === "1" && (
									<BuyerDetailsStep2
										upperState={state}
										setUpperState={setState}
										setBackDrop={setBackDrop}

									/>
								)}
								{false && props.step === "2" && (
									<SellerDetailsStep3
										upperState={state}
										setUpperState={setState}
										setBackDrop={setBackDrop}

									/>
								)}
								{props.step === "2" && (
									<Stack>
										<TunnelTerminaison state={state} setState={setState} />
										<Box
											display="flex"
											alignItems="center"
											justifyContent="flex-end"
											p={1}
											m={1}
											style="padding: 0px; margin: 0px;"
										>
											<Box p={1} style="padding: 0px; margin: 0px; " >
												<Button
													variant="contained"
													onClick={() => {
														window.location.replace("/dashboardp");
													}}
												>
													Aller dans mon espace
												</Button>
											</Box>
										</Box>
									</Stack>

								)}
							</Paper>
						</Grid>
					</Grid>
				</Grid>

			</Grid>
		</div >
	);
}

//
//
